import React, { useState } from "react";
import AppIcon from "src/commun/composants/AppIcon";
import { AdminAccessGroup } from "src/domain/AdminAccessGroup";
import styles from "src/pages/admin/adminAccessGroup/AdminAcessGroupeForm.scss";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useFormikContext } from "formik";
import AppSelectFormik from "src/commun/composants/formulaire/formik/fields/AppSelectFormik";
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";

const AdminAccessGroupAddLigne = ({ accessGroup, onEdit, onDelete }: {
  accessGroup: AdminAccessGroup;
  onEdit: () => void;
  onDelete: () => void
}) => {
  const [isAdd, setIsAdd] = useState(false);

  const [editedAccessGroup, setEditedAccessGroup] = useState(accessGroup);
  const { submitCount ,submitForm} = useFormikContext();


  const callSubmit = () =>{

    submitForm();
  }

  const typeAcces:AppSelectOption[]= [{value:"Interne",label:"Interne"},{value:"Entreprise",label:"Entreprise"}]
  return (
    <tr>
      {isAdd ? (
        <>
          <td><AppInputFormik name="accessGroup" formulaireSoumis={submitCount > 0} isRequired={false}/>
         </td>
          <td>
            <AppSelectFormik
              options={
                typeAcces
              }

              name="typeAcces"
              formulaireSoumis={submitCount > 0}
              defaultValue={""}
            />
           </td>
        </>
      ) : (
        <>
          <td></td>
          <td></td>
        </>
      )}
      <td>
        {isAdd ? (
          <>
            <input
              className={`btn__primary mt-3 btn--full--xs mr-5`}
              type="submit"
              name="valider"
              onClick={callSubmit}
              value={"Sauvegarder"}
            />
            <input
              className={`btn__primary mt-3 btn--full--xs mr-5`}
              type="button"
              name="annuler"
              onClick={()=>{setIsAdd(false)}}
              value={"annuler"}
            />

            <AppIcon
              name="cancel"
              className={"icon-ajouter"}
              active
              size="38px"
              onClick={() => {
                setEditedAccessGroup(accessGroup);
                setIsAdd(false);
              }}
            />
          </>
        ) : (
          <>
            <AppIcon
              name="add"
              className={"icon-ajouter"}
              active
              size="38px"
              onClick={() => setIsAdd(true)}
            />

          </>
        )}
      </td>
    </tr>
  );
};


export default AdminAccessGroupAddLigne;
